import { supabase } from '../supabase/supabaseClient'

export const fetchUpdates = async (limit = 5) => {
  try {
    const { data, error } = await supabase
      .from('updates')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(limit)

    if (error) {
      console.error('Error fetching updates:', error)
      throw error
    }

    return data || []
  } catch (error) {
    console.error('Error in fetchUpdates:', error)
    return []
  }
}